import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { isSameDay } from '../util/util';
import { Entity } from './entity';

export interface Record extends Entity {
  habitId: string;
  date: Date;
  createdAt: Date;
  target: number;
  achievement: number;
}

export interface FirestoreRecord extends Omit<Record, 'date' | 'createdAt'> {
  date: Timestamp;
  createdAt: Timestamp;
}

export const RecordConverter: FirestoreDataConverter<Record, FirestoreRecord> = {
  toFirestore: (record: Record): FirestoreRecord => {
    return {
      ...record,
      date: Timestamp.fromDate(record.date),
      createdAt: Timestamp.fromDate(record.createdAt),
    };
  },
  fromFirestore: (snapshot, options): Record => {
    const record = snapshot.data(options) as FirestoreRecord;
    return {
      ...record,
      date: record.date.toDate(),
      createdAt: record.createdAt.toDate(),
    };
  },
};

export function getTodaysRecord(records?: Record[]): Record | undefined {
  const latestRecord = records?.at(-1);
  return isSameDay(latestRecord?.date, new Date()) ? latestRecord : undefined;
}

export const RecordCollection = 'records';
